import * as Yup from 'yup';

/**
 * Column limits come straight from the `assetType` DDL
 * (`asset-manager.sql`): `code VARCHAR(100) CHARACTER SET ascii`,
 * `description VARCHAR(225)`.
 */
export const ASSET_TYPE_CODE_MAX = 100;
export const ASSET_TYPE_DESCRIPTION_MAX = 225;

const ASCII_ONLY = /^[\x20-\x7E]*$/;

export const assetTypeValidationRules = Yup.object().shape({
  code: Yup.string().required(),
  description: Yup.string().required(),
  properties: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required(),
      value: Yup.string().required(),
    }),
  ),
});

export const assetTypeImportRowRules = Yup.object().shape({
  code: Yup.string()
    .trim()
    .required('Code is required')
    .max(ASSET_TYPE_CODE_MAX, `Code must be ${ASSET_TYPE_CODE_MAX} characters or fewer`)
    .matches(ASCII_ONLY, 'Code must use ASCII characters only'),
  description: Yup.string()
    .trim()
    .required('Description is required')
    .max(
      ASSET_TYPE_DESCRIPTION_MAX,
      `Description must be ${ASSET_TYPE_DESCRIPTION_MAX} characters or fewer`,
    ),
});
